
const Supplier = (state) => state.Supplier;
const Suppliers = (state) => state.Suppliers;
const TotalInfo = (state) => state.TotalInfo;
export default { Supplier, Suppliers, TotalInfo }